import { BaseInputTemplateProps } from '@rjsf/utils';
import { Templates } from '@rjsf/mui';

const CustomBaseInputTemplate = (props: BaseInputTemplateProps) => {
  const { BaseInputTemplate } = Templates;
  if (!BaseInputTemplate) {
    throw new Error("BaseInputTemplate is not defined.");
  }

  return <BaseInputTemplate {...props} size="small" variant="outlined" />;
};

export default CustomBaseInputTemplate;
